var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWideRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37097 6.17442L1.23592 0.639535C1.0638 0.453488 0.791269 0.453488 0.633488 0.639535C0.461363 0.825581 0.461363 1.12016 0.633488 1.2907L5.46732 6.5L0.633487 11.7093C0.461363 11.8953 0.461363 12.1899 0.633487 12.3605C0.71955 12.4535 0.834299 12.5 0.934705 12.5C1.04945 12.5 1.14986 12.4535 1.23592 12.3605L6.37097 6.82558C6.45703 6.73256 6.50006 6.62403 6.50006 6.5C6.50006 6.37597 6.45703 6.25194 6.37097 6.17442Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWideRightArrow);
export default __webpack_public_path__ + "static/media/wide-right-arrow.37da1ad1.svg";
export { ForwardRef as ReactComponent };